import React, { useCallback } from "react";
import { Modal, Form, Input } from "antd";
import { Validator } from "@/utils/validator";

const DeleteUserModal = ({ formRef, open, onClose, isLoading, onSubmit }) => {
  // Forward the reason to the parent component
  const handleSubmit = useCallback(
    ({ reason }) => {
      onSubmit(reason);
    },
    [onSubmit],
  );

  return (
    <Modal title="Delete User" open={open} onCancel={onClose} onOk={formRef.submit} confirmLoading={isLoading}>
      <Form form={formRef} onFinish={handleSubmit} layout="vertical">
        <Form.Item name="reason" label="Reason" rules={[Validator.required("Please enter a reason")]}>
          <Input.TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DeleteUserModal;
